/* eslint-disable */
import EscapeIcon from "components/nav-components/nav-icons/escape-icon";
import "./playerActivityHeader.scss";
import { nanoid } from "@reduxjs/toolkit";
import MainTooltip from "components/common/mainTooltip/MainTooltip";
import EditIcon from "components/common/icons/editIcon";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getupdateSessionDetail } from "store/sessionListSlice";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const PlayerActivityHeader = (props) => {
  const {
    closeModalActions,
    playerImageUrl,
    playerName,
    playerOrganisation,
    playerOrganisationIcon,
    playerSessionInfo,
    playerSessionDetails,
    thisSession = false,
    session,
    selectedSessionId,
    gotToAthletePageProtocol,
    athleteLinkTo,
    sessionTags,
    incompleteSession
  } = props;

  const dispatch = useDispatch();

  const [textareaValue, settextareaValue] = useState("");
  const [editForm, setEditForm] = useState(false);

  //screen width toggler for screen sizes below 844px
  const [tableAndBelowScreenSize, setTableAndBelowScreenSize] = useState(false);

  useEffect(() => {
    const updateTableAndBelowScreenSize = () => {
      const windowWidth = window.innerWidth;

      if (windowWidth <= 844) {
        setTableAndBelowScreenSize(true); // For very small screens
      } else {
        setTableAndBelowScreenSize(false); // For larger screens
      }
    };

    updateTableAndBelowScreenSize();

    window.addEventListener("resize", updateTableAndBelowScreenSize);

    return () => {
      window.removeEventListener("resize", updateTableAndBelowScreenSize);
    };
  }, [window.innerWidth]);

  function displaySessionDetail(thisSession = {}) { // added thisSession = {} as undefinded destructure error might occur
    const { name, detail, playerName } = thisSession;

    if (detail && detail !== "Add Description" && detail !== "") {
      if (name && name !== "Add Description" && name !== "") {
        if (name.includes(playerName)) {
          return detail;
        } else {
          return `${detail}, ${name}`;
        }
      } else if (name !== playerName) {
        return detail;
      }
    } else if (
      name &&
      name !== "Add Description" &&
      name !== "" &&
      name !== playerName
    ) {
      return name;
    }

    return "-";
  }

  const showDetailForm = () => {
    let thisSession;

    if (session.sessionList.status === 200) {
      thisSession = session?.sessionList?.data.find(
        (s) => s.ID === selectedSessionId
      );
    }

    setEditForm(true);
    settextareaValue(thisSession?.detail);
    setTimeout(() => {
      document.getElementById("player_sesssion_input").value =
        displaySessionDetail(thisSession);
    }, 100);
  };

  const handleChange = (event) => {
    settextareaValue(event.target.value);
  };

  const handleBlur = () => {
    if (textareaValue === thisSession.detail || textareaValue === "") {
      setEditForm(false);
      return;
    }
    const newDesc = {
      id: thisSession.ID,
      detail: textareaValue,
    };
    dispatch(getupdateSessionDetail(newDesc));
    settextareaValue("");
    setEditForm(false);
  };

  return (
    <>
    <div className={`player_activity_header_container`}>
      {/* ------------------------------------------------------------------------------*/}
      <div className="player_activity_header_profile">
        <div className="player_actvity_header_player_image">
          {playerImageUrl ? (
            <img
              className="header_player_image_size"
              src={playerImageUrl}
              alt="Athlete Image"
            />
          ) : (
            <div className="header_player_image_placeholder"></div>
          )}
        </div>
        <div className="player_actvity_header_player_name">
          {playerName ? (
            <Link to={athleteLinkTo} onClick={() => gotToAthletePageProtocol()}>
              <h3>{playerName}</h3>
            </Link>
          ) : (
            <h3>Name not Found</h3>
          )}
          {playerOrganisation ? (
            <div className="header_player_org">
              {playerOrganisationIcon ? (
                <img
                  className="header_player_org_image_size"
                  src={playerOrganisationIcon}
                  alt="Athlete Image"
                />
              ) : null}
              <h5>{playerOrganisation}</h5>
            </div>
          ) : null}
        </div>
      </div>
      {/* ------------------------------------------------------------------------------*/}
      <div className="player_actvity_header_player_info">
        {playerSessionInfo.map((item) => (
          <div className="player_session_info" key={nanoid()}>
            <div className="player_heading">
              {item.title}{" "}
              {item.hasTooltip ? (
                <MainTooltip tooltipText={item.tooltipValue} iconSize={15} />
              ) : null}
            </div>
            <div className="player_info_info">{item.value}</div>
          </div>
        ))}
      </div>
      {/* ------------------------------------------------------------------------------*/}
      <div className="player_activity_header_player_notes_plus_tags">
        <div
          className="player_actvity_header_player_notes"
          onClick={() => showDetailForm()}
        >
          <div className="player_heading">
            Notes{" "}
            <div className="player_notes_edit_button">
              <EditIcon />
            </div>
          </div>
          {editForm ? (
            <textarea
              id="player_sesssion_input"
              placeholder={playerSessionDetails}
              onBlur={handleBlur}
              onChange={handleChange}
              value={textareaValue}
              autoFocus={true}
            />
          ) : (
            <div className="player_notes">
              <p>{displaySessionDetail(thisSession)}</p>
            </div>
          )}
        </div>

        <div className="player_actvity_header_player_tags">
          <div className="player_heading">Tags</div>
          {!tableAndBelowScreenSize ? (
            <div className="player_tags_container">
              {sessionTags.slice(0, 2).length === 0 ? (
                <div className="tag_counter">{`No tags assigned`}</div>
              ) : null}
              {sessionTags.slice(0, 2).map((item) => (
                <div className="tag" key={item.TID}>
                  <p>{item.tag}</p>
                </div>
              ))}
              {sessionTags.slice(2).length === 1
                ? sessionTags.slice(2).map((item) => (
                    <div className="tag" key={item.TID}>
                      <p>{item.tag}</p>
                    </div>
                  ))
                : null}
              {sessionTags.slice(2).length > 1 ? (
                <div className="tag_counter">
                  {`+${sessionTags.slice(2).length} more`}
                  <span className="tag_counter_tooltip">
                    {sessionTags.slice(2).map((item) => (
                      <div className="tag" key={item.TID}>
                        <p>{item.tag}</p>
                      </div>
                    ))}
                  </span>
                </div>
              ) : null}
              {/* {sessionTags.slice(2).map(item => (
							<div className="tag" key={item.TID}>{item.tag}</div>
						))} */}
            </div>
          ) : (
            <div className="player_tags_container">
            {sessionTags.slice(0, 1).length === 0 ? (
              <div className="tag_counter">{`No tags assigned`}</div>
            ) : null}
            {sessionTags.slice(0, 1).map((item) => (
              <div className="tag" key={item.TID}>
                <p>{item.tag}</p>
              </div>
            ))}
            {sessionTags.slice(1).length > 0 ? (
              <div className="tag_counter_tablet">
                {`+${sessionTags.slice(1).length}`}
                <span className="tag_counter_tooltip">
                  {sessionTags.slice(1).map((item) => (
                    <div className="tag" key={item.TID}>
                      <p>{item.tag}</p>
                    </div>
                  ))}
                </span>
              </div>
            ) : null}
          
          </div>
          )}
        </div>
      </div>
      {/* ------------------------------------------------------------------------------*/}
      <div
        className="player_actvity_header_close"
        onClick={() => closeModalActions()}
      >
        <EscapeIcon size="18px" color="white" />
      </div>
    </div>
    {incompleteSession ? 
    <div className="player_activity_incomplete">
      <h3>This session is missing data, please go to the app and complete the upload.</h3>
    </div> : null}
    </>
  );
};

export default PlayerActivityHeader;
